import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Home'
import Features from '@/pages/features/Features'
import Educator from '@/pages/educator/Educator'
import Curriculum from '@/pages/curriculum/Curriculum'
import Help from '@/pages/help/Help'
import NotFound from '@/pages/NotFound'
import HelpApp from '@/pages/help/AppView'

// import Redirect from '@/pages/Redirect'
// import Signin from '@/pages/account/Signin'
// import SigninEmail from '@/pages/account/SigninEmail'
// import SignupEmail from '@/pages/account/SignupEmail'
// import Signout from '@/pages/account/Signout'
// import Recover from '@/pages/account/Recover'
// import SignupAgreement from '@/pages/account/SignupAgreement'
// import Wageni from '@/pages/promotion/Wageni'

import { store } from '@/store'
import VueCookies from 'vue-cookies'

Vue.use(Router);

const languageCookie = VueCookies.get('cloudfront-viewer-country')// || VueCookies.get('language')).toLowerCase()

const isDev = location.hostname.indexOf('rc.') === 0 || location.hostname == 'localhost'
const redirectDomain = isDev ? 'https://rc.todoschool.com' : 'https://todoschool.com'

const isEnumaCN = location.hostname.indexOf('enuma.cn') > -1 // location.hostname === 'enuma.cn' || location.hostname === 'www.enuma.cn'
const isTodoMath = location.hostname.indexOf('todomath.com') > -1 //location.hostname === 'todomath.com' || location.hostname === 'www.todomath.com'

const checkRedirect = () => (to, from, next) => {
    if (languageCookie === 'CN' && isTodoMath && to.path === '/' || isEnumaCN || isDev && location.search === '?t=todokids') {
        location.href = `https://${isDev ? 'rc.' : ''}todokids.cn`

    } else {
        const redirectLocale = languageCookie == 'KR' ? '/kr' : languageCookie == 'JP' ? '/jp' : '/en'
        if (to.path.indexOf('/curriculum') == 0) {
            location.href = redirectDomain + `${redirectLocale}/math/curriculum`

        } else if (to.path == '/educators') {
            let redirectPath

            if (redirectLocale == '/kr' || redirectLocale == '/en') {
                redirectPath = `${redirectLocale}/math/educator`
            } else {
                redirectPath = `${redirectLocale}/math`
            }
            
            location.href = redirectDomain + redirectPath

        } else if (to.path.indexOf('/help') == 0) {
            location.href = redirectDomain + `${redirectLocale}/math/help`

        } else {
            next(redirectLocale)

        }
    }
}

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			name: 'NotFoundPage',
			component: NotFound,
		},
		{
			path: '/',
			name: 'Home',
			component: Home,
			props: true,
            beforeEnter: checkRedirect()
		},
        {
			path: '/en',
			beforeEnter() {
                location.href = redirectDomain + '/en/math'
			},
		},
		{
			path: '/kr',
			beforeEnter() {
                location.href = redirectDomain + '/kr/math'
			},
		},
		{
			path: '/jp',
			beforeEnter() {
                location.href = redirectDomain + '/jp/math'
			},
		},
		{
			path: '/cn',
			redirect: '/'
		},
		{
			path: '/features',
			name: 'Features',
			component: Features,
			beforeEnter: checkRedirect()
		},
		{
			path: '/educators',
			name: 'Educator',
			component: Educator,
            beforeEnter: checkRedirect()
		},
		{
			path: '/curriculum',
			redirect: '/curriculum/guide',
			props: true,
            beforeEnter: checkRedirect()
		},
		{
			path: '/curriculum/:menu',
			name: 'Curriculum',
			component: Curriculum,
			props: true,
            beforeEnter: checkRedirect()
		},
		{
			path: '/curriculum/:menu/:submenu',
			name: 'CurriculumSubmenu',
			component: Curriculum,
			props: true,
            beforeEnter: checkRedirect()
		},
		{
			path: '/help',
			redirect: '/help/faqs',
			props: true,
		}, {
			path: '/help/:subject',
			name: 'Help',
			component: Help,
			props: true,
            beforeEnter: checkRedirect()
		}, {
			path: '/help/:subject/:target',
			name: 'HelpDetail',
			component: Help,
			props: true,
            beforeEnter: checkRedirect()
		},
        {
			path: '/helpinapp',
			redirect: '/helpinapp/faqs',
			props: true
		}
		, 
        {
			path: '/helpinapp/:subject',
			name: 'HelpApp',
			component: HelpApp,
			props: true
		}, {
			path: '/helpinapp/:subject/:target',
			name: 'HelpAppDetail',
			component: HelpApp,
			props: true
		}, 
/*
        {
			path: '/signin',
			name: 'Signin',
			component: Signin,
			props: true
		}, {
			path: '/signin/email',
			name: 'SigninEmail',
			component: SigninEmail,
			props: true
		}, {
			path: '/signup/email',
			name: 'SignupEmail',
			component: SignupEmail,
			props: true
		}, {
			path: '/signout',
			name: 'Signout',
			component: Signout,
			props: true
		}, {
			path: '/recover',
			name: 'Recover',
			component: Recover,
			props: true,
		}, {
			path: '/signupAgreement',
			name: 'signupAgreement',
			component: SignupAgreement,
			props: true,
		}, {
			path: '/promotion/wgn/:id',
			name: 'Wageni',
			component: Wageni,
			props: true,
			beforeEnter: requireAuth()
		}
*/
	],
	scrollBehavior(to, from, savedPosition) {

		if (to.fullPath != from.fullPath) {
			return { x: 0, y: 0 }

		} else {
			if (savedPosition) {
				return savedPosition;

			} else {
				return { x: 0, y: 0 }
			}
		}

	}
})



// WEBPACK FOOTER //
// ./src/router/index.js